import React from 'react';
import ReactMarkdown from 'react-markdown';
import { getValidDateAppearance } from './utils';

const ProjectsItems = ({ x }) => (
  <>
    <div className="col-span-5 px-10 py-10 pb-4" style={{ borderRight: '2px solid #c63031' }}>
      {(x.key || x.alternativeName) && (
        <div style={{ fontSize: 16, color: '#c63031' }} className="uppercase font-bold">
          {(!x.isShowName ? '' : x.key || '') +
            (x.alternativeName && x.key && x.isShowName ? ' - ' : '') +
            (x.alternativeName ? x.alternativeName : '')}
        </div>
      )}
      {x.body && <ReactMarkdown className="text-sm py-4" source={x.body.replace(/\n/gi, '\n\n')} />}
    </div>
    <div className="col-span-7 px-10 py-10">
      {x.role && (
        <div>
          <div className="font-bold tracking-wide" style={{ fontSize: 14 }}>
            Projects Roles
          </div>
          <div style={{ paddingTop: 6 }}>{x.role}</div>
        </div>
      )}

      <div>
        <div className="mt-3 font-bold tracking-wide" style={{ fontSize: 14 }}>
          Period
        </div>
        <div style={{ paddingTop: 6 }}>{getValidDateAppearance(x.start, x.end)}</div>
      </div>

      {x.tasksExecuted && (
        <div>
          <div className="mt-3 font-bold tracking-wide" style={{ fontSize: 14 }}>
            Responsibilities & achievements
          </div>
          <ul className="pl-5" style={{ paddingTop: 6 }}>
            {x.tasksExecuted
              .split(/\n/gi)
              .filter((text) => text)
              .map((responsibility) => {
                return (
                  <li key={responsibility} className="text-sm pt-2 list-disc">
                    {responsibility}
                  </li>
                );
              })}
          </ul>
        </div>
      )}

      {x.task_body && (
        <div>
          <div className="mt-3 font-bold tracking-wide" style={{ fontSize: 14 }}>
            Environment
          </div>
          <ReactMarkdown
            style={{ paddingTop: 6 }}
            className="text-sm"
            source={x.task_body.replace(/\n/gi, '\n\n')}
          />
        </div>
      )}
    </div>
  </>
);

export default ProjectsItems;
